/**
 * contiene la información para el manejo de identificación de peligros a la salud.
 */
export const defaultIdentificacionPe = () => {
    return {
        id_producto:'',
        efecto_cronico:'',
        cancerigeno : '',
        organos_ataca:'',
        cronicos_salud:'',
        activo:1
    }
}

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    selectedIdentificacionPe: defaultIdentificacionPe()
}